
import React from 'react';
import { Badge } from "@/components/ui/badge";

export interface CircularItemProps {
  id: number;
  title: string;
  issuer: string;
  date: string;
  summary: string;
}

const CircularItem: React.FC<CircularItemProps> = ({ title, issuer, date, summary }) => {
  return (
    <div className="border-b pb-3 last:border-0">
      <div className="flex items-center justify-between">
        <h4 className="font-medium">{title}</h4>
        <Badge>{issuer}</Badge>
      </div>
      <p className="text-xs text-muted-foreground mt-1">Published: {date}</p>
      <p className="text-sm mt-2">{summary}</p>
    </div>
  );
};

export default CircularItem;
